import bdapi from "@bd-core/bd-api";
import bdjs from "@bd-core/bdjs";
import $ from "jquery";

export const AccessPage = () => {
    const isAccessPage = $("#access-page").length > 0;
    if (!isAccessPage) return false;

    bdjs.hideLoading();

    $(".js-submit-password").prop("disabled", true);

    const handlePasswordSubmit = async () => {
        const [response] = await bdjs.goAsync(
            bdapi.post("public/check-password", {
                password: $(".js-password-input").val(),
            }),
        );

        if(response.data.data.status === "invalid") {
            $(".password-popup__content__body").addClass("is-error");
            $(".js-submit-password").prop("disabled", true);
            return;
        }

        window.location.href = response.data.data.redirect;
    };

    $(document).on("input", ".js-password-input", (e) => {
        const inputValue = $(e.target).val();
        const isError = $(".password-popup__content__body").hasClass("is-error");

        if (isError) {
            $(".password-popup__content__body").removeClass("is-error");
        }

        $(".js-submit-password").prop("disabled", !inputValue);
    });

    $(document).on("click", ".js-submit-password", handlePasswordSubmit);
    $(document).on("keypress", ".js-password-input", (e) => {
        if (e.which === 13) {
            handlePasswordSubmit();
        }
    });

    const togglePasswordVisibility = () => {
        const passwordInput = $('.js-password-input');
        const currentType = passwordInput.attr('type');
        passwordInput.attr('type', currentType === 'password' ? 'text' : 'password');
        $(".password-popup__content__body").toggleClass("is-password-visible");
    };

    $(document).on('click', '.js-toggle-password', togglePasswordVisibility);
};
